var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGraficoBarras01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_17_",
    d: "M33.6,35.5H2.4v-3.9h31.1V35.5z M31.6,27.7h-3.9V0.5h3.9V27.7z M23.8,27.7h-3.9V6.3h3.9V27.7z M16.1,27.7 h-3.9V12.2h3.9V27.7z M8.3,27.7H4.4V18h3.9V27.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGraficoBarras01);
export default __webpack_public_path__ + "static/media/ico-grafico-barras-01.5e0a787483a5590a863d2c037b363f89.svg";
export { ForwardRef as ReactComponent };